class AudioPlayer {
  constructor(el) {
    this.el = el
    this.audio = this.el.querySelector('.audio-player__media')
    this.playToggle = this.el.querySelector('[data-js="play-toggle"]')
    this.muteToggle = this.el.querySelector('[data-js="mute-toggle"]')
    this.menuToggle = this.el.querySelector('[data-js="menu-toggle"]')
    this.menu = this.el.querySelector('[data-js="menu"]')
    this.seek = this.el.querySelector('[data-js="seek"]')
    this.currentTime = this.el.querySelector('[data-js="current-time"]')
    this.duration = this.el.querySelector('[data-js="duration"]')

    if (!this.audio || !this.playToggle || !this.seek) return

    this.bindEvents()
    this.updateDuration()
    this.updateProgress()
  }

  bindEvents() {
    this.playToggle.addEventListener('click', this.togglePlayback.bind(this))
    this.muteToggle.addEventListener('click', this.toggleMuted.bind(this))
    this.seek.addEventListener('input', this.seekAudio.bind(this))
    this.audio.addEventListener('durationchange', this.updateDuration.bind(this))
    this.audio.addEventListener('loadedmetadata', this.updateDuration.bind(this))
    this.audio.addEventListener('timeupdate', this.updateProgress.bind(this))
    this.audio.addEventListener('play', this.updatePlaybackState.bind(this))
    this.audio.addEventListener('pause', this.updatePlaybackState.bind(this))
    this.audio.addEventListener('ended', this.updatePlaybackState.bind(this))

    if (this.menuToggle && this.menu) {
      this.menuToggle.addEventListener('click', this.toggleMenu.bind(this))
      document.addEventListener('click', this.closeMenuOnOutsideClick.bind(this))
      document.addEventListener('keydown', this.closeMenuOnEscape.bind(this))
    }
  }

  togglePlayback() {
    if (this.audio.paused) {
      this.audio.play()
    } else {
      this.audio.pause()
    }
  }

  updatePlaybackState() {
    const isPlaying = !this.audio.paused && !this.audio.ended

    this.el.classList.toggle('-playing', isPlaying)
    this.playToggle.setAttribute('aria-label', isPlaying ? 'Pause' : 'Play')
  }

  toggleMuted() {
    this.audio.muted = !this.audio.muted
    this.el.classList.toggle('-muted', this.audio.muted)
    this.muteToggle.setAttribute('aria-label', this.audio.muted ? 'Unmute' : 'Mute')
  }

  seekAudio() {
    if (!this.audio.duration) return

    this.audio.currentTime = (this.seek.value / 100) * this.audio.duration
    this.updateProgress()
  }

  updateDuration() {
    this.duration.innerText = this.formatTime(this.audio.duration)
  }

  updateProgress() {
    const duration = this.audio.duration || 0
    const currentTime = this.audio.currentTime || 0
    const progress = duration ? (currentTime / duration) * 100 : 0

    this.currentTime.innerText = this.formatTime(currentTime)
    this.seek.value = progress
    this.seek.style.setProperty('--audio-progress', `${progress}%`)
  }

  toggleMenu(e) {
    e.stopPropagation()

    const isOpen = this.menuToggle.getAttribute('aria-expanded') === 'true'
    this.setMenuOpen(!isOpen)
  }

  closeMenuOnOutsideClick(e) {
    if (!this.el.contains(e.target)) {
      this.setMenuOpen(false)
    }
  }

  closeMenuOnEscape(e) {
    if (e.key === 'Escape') {
      this.setMenuOpen(false)
      this.menuToggle.focus()
    }
  }

  setMenuOpen(isOpen) {
    this.menu.hidden = !isOpen
    this.menuToggle.setAttribute('aria-expanded', isOpen)
  }

  formatTime(time) {
    if (!Number.isFinite(time)) return '0:00'

    const minutes = Math.floor(time / 60)
    const seconds = Math.floor(time % 60).toString().padStart(2, '0')

    return `${minutes}:${seconds}`
  }
}

export default AudioPlayer
